/**
 * 画布视频上传（平台媒体库，持久保存）
 *
 * 与图片不同，视频不走 blob 乐观预览：画布上的视频一律要求是线上可提交的持久地址
 * （可作为下游参考视频），因此上传完成拿到网关地址后才写入节点。
 */
import { platformFetch, readEnvelope } from '../../../platform/http';
import { toPersistableMediaUrl } from './persistableMediaUrl';

export interface UploadedVideo {
  /** 持久网关地址（已剥离 mediaToken 等展示期参数） */
  url: string;
  storageKey: string;
  durationSec: number | null;
}

/** 上传本地视频文件到平台媒体库，返回可写入节点的持久地址 */
export async function uploadVideoFile(file: File): Promise<UploadedVideo> {
  const formData = new FormData();
  formData.append('file', file);
  const data = await readEnvelope<{ storageKey: string; url: string; durationSec?: number | null }>(
    await platformFetch('/videos/upload-video?persist=1', {
      method: 'POST',
      body: formData,
    }),
    '视频上传失败'
  );
  const url = toPersistableMediaUrl(data.url);
  if (!url) throw new Error('视频上传失败');
  return { url, storageKey: data.storageKey, durationSec: data.durationSec ?? null };
}
